var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 580 460"}},[_c('g',{style:(_vm.styleObject),attrs:{"transform":`translate(${_vm.decoration.position_x},${_vm.decoration.position_y})`},domProps:{"innerHTML":_vm._s(_vm.picture.image)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }